import React, { Component } from 'react'
import Header from '../Header';
import styles from './ChallengeWorkSpace.module.css'
import { withRouter } from 'react-router-dom'
import { rwbApi } from '../../../../shared/apis/api';
import DocumentIcon from '../svgs/DocumentIcon';
import { errorAlert } from '../../../../shared/utils/ErrorAlert';

export class ChallengeWorkSpace extends Component {

    downloadWorkspaceLeaderboardCsv = (workspace_id, workspace_name) => {
        this.setState({ isDownloading: true });
        rwbApi
          .getWorkspaceLeaderboardCsv(workspace_id)
          .then((blob) => {
            const link = document.createElement('a');
            link.download = `${workspace_name}-leaderboard.csv`;
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // wait just a tick before re-enabling the download button
            setTimeout(() => {
                this.setState({ isDownloading: false });
              }, 3000);
          })
          .catch((error) => {
            console.warn('error getting csv: ', error);
            errorAlert("Error downloading workspace leaderboard CSV");
            this.setState({ isDownloading: false });
          });
      };
    downloadWorkspaceAttendeeCsv = (workspace_id, workspace_name) => {
        this.setState({ isDownloading: true });
        rwbApi
          .getWorkspaceAttendeeCsv(workspace_id)
          .then((blob) => {
            const link = document.createElement('a');
            link.download = `${workspace_name}-attendees.csv`;
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // wait just a tick before re-enabling the download button
            setTimeout(() => {
                this.setState({ isDownloading: false });
              }, 3000);
          })
          .catch((error) => {
            console.warn('error getting csv: ', error);
            errorAlert("Error downloading workspace attendee CSV");
            this.setState({ isDownloading: false });
          });
      };
    downloadWorkspaceUserCsv = (workspace_id, workspace_name) => {
        this.setState({ isDownloading: true });
        rwbApi
          .getWorkspaceUserCsv(workspace_id)
          .then((blob) => {
            const link = document.createElement('a');
            link.download = `${workspace_name}-user.csv`;
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // wait just a tick before re-enabling the download button
            setTimeout(() => {
                this.setState({ isDownloading: false });
              }, 3000);
          })
          .catch((error) => {
            console.warn('error getting csv: ', error);
            errorAlert("Error downloading workspace user CSV");
            this.setState({ isDownloading: false });
          });
      };

    state = {
        isDownloading: false
    };
    render() {
        const { workspaceData, titleName } = this.props.location.state
        const {history} = this.props
        const { isDownloading } = this.state;
        return (
            <div> 
                <div className={[styles.headerContainer]}>
                <Header title={titleName} onBack={() => {history.goBack() }} />
                </div>
               
                <div className={[styles.contentContainer]}>
                    <div className={[styles.challengeEventContainer]}>
                        {titleName == "Events" ? (
                            <>
                                <div
                                    className={isDownloading ? `${styles.csvButton} ${styles.csvDisabled}` : styles.csvButton}
                                    onClick={!isDownloading ? () => this.downloadWorkspaceAttendeeCsv(
                                        workspaceData.workspace_id,
                                        workspaceData.workspace_name)
                                        :
                                        undefined}
                                >
                                    <DocumentIcon 
                                        tintColor={'var(--white)'}
                                    />
                                    {isDownloading ? 'Prepping CSV...' : 'Attendee Report (CSV)'}
                                </div>

                                <div className={styles.metricHeader}>
                                    <h2>Event</h2>
                                    <h2>Attendees</h2>
                                </div>

                                {workspaceData.events.map((item, index) => (
                                    <div className={[`${styles.metricBox}`]}>
                                        <p className={[styles.metricLable]}>{item.event_name}</p>
                                        <div className={[styles.metricLable]}>
                                            {item.total_participants}
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : titleName == "Challenges" ? (
                            <>
                                <div
                                    className={isDownloading ? `${styles.csvButton} ${styles.csvDisabled}` : styles.csvButton}
                                    onClick={!isDownloading ? () => this.downloadWorkspaceLeaderboardCsv(
                                        workspaceData.workspace_id,
                                        workspaceData.workspace_name)
                                        :
                                        undefined}
                                >
                                    <DocumentIcon 
                                        tintColor={'var(--white)'}
                                    />
                                    {isDownloading ? 'Prepping CSV...' : 'Leaderboard Report (CSV)'}
                                </div>

                                <div className={styles.metricHeader}>
                                    <h2>Challenge</h2>
                                    <h2>Participants</h2>
                                </div>

                                {workspaceData.challenges.map((item, index) => (
                                    <div className={[`${styles.metricBox}`]}>
                                        <p className={[styles.metricLable]}>{item.challenge_name}</p>
                                        <div className={[styles.metricLable]}>
                                            {item.total_participants}
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : titleName == "Users" && (
                            <>
                               <div
                                    className={isDownloading ? `${styles.csvButton} ${styles.csvDisabled}` : styles.csvButton}
                                    onClick={!isDownloading ? () => this.downloadWorkspaceUserCsv(
                                        workspaceData.workspace_id,
                                        workspaceData.workspace_name)
                                        :
                                        undefined}
                                >
                                    <DocumentIcon 
                                        tintColor={'var(--white)'}
                                    />
                                    {isDownloading ? 'Prepping CSV...' : 'User Report (CSV)'}
                                </div>
                                
                                <div className={styles.metricHeader}>
                                    <h2>Name</h2>
                                    <h2>Date Joined</h2>
                                </div>
                                {workspaceData.users.map((item, index) => (
                                    <div className={[`${styles.metricBox}`]}>
                                        <p className={[styles.metricLable]}>{item.full_name}</p>
                                        <div className={[styles.metricLable]}>
                                            {item.date_joined}
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(ChallengeWorkSpace)